import React, { useState, useEffect } from "react";
import "./ViewVideo.css";
import { API_BASE_URL, LOGOUT_URL } from "./config";
import CustomHLSPlayer from "./CustomHLSPlayer.jsx";

const ViewVideo = (props) => {
  const [videoError, setVideoError] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);

  const filename = props.props;
  const logoutUrl = LOGOUT_URL;
  const studentUniqueId = localStorage.getItem("student_unique_id");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchSignedUrl = async () => {
      console.log("view video started");
      if (!studentUniqueId || !token) {
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/generate_signed_hls_url?filename=${encodeURIComponent(
            filename
          )}&student_id=${encodeURIComponent(studentUniqueId)}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          }
        );


        if (response.status === 403) {
          // ✅ Handle 403 (Forbidden)
          alert(
            "You seem to be logged in on another device/browser. Logging out from here."
          );
          localStorage.removeItem("student_unique_id");
          localStorage.removeItem("token");
          window.location.href = logoutUrl;
          return;
        } else if (response.status === 401) {
          // ✅ Handle 401 (Unauthorized/Session expired)
          alert("Your session has expired. Please log in again.");
          localStorage.removeItem("student_unique_id");
          localStorage.removeItem("token");
          window.location.href = logoutUrl;
          return;
        }

        const data = await response.json();
        console.log("✅ Received Signed Token:", data.signed_url); // Debugging log

        if (response.status === 200) {
          const streamUrl = `${API_BASE_URL}/stream_hls/${encodeURIComponent(
            data.signed_url
          )}`;
          console.log("✅ Streaming URL:", streamUrl); // Debugging log
          setVideoUrl(streamUrl);
          setVideoError(null);
        } else {
          throw new Error(data.detail);
        }
      } catch (error) {
        console.error("Error fetching signed URL:", error.message);
        setVideoError("❌ An unexpected error occurred.");
      }
    };

    if (filename) {
      fetchSignedUrl();
    }
  }, [filename, studentUniqueId, token, logoutUrl]);

  // STUDENT EXPLORATION GUIDANCE V1
  return (
    <div className="row-container student-learning-workspace">
      <div className="player-container">
        {videoError ? (
          <div className="video-error">
            Video is not available. Please contact the technical team of{" "}
            <strong>StudyAIPlacement</strong>.
          </div>
        ) : (
          <CustomHLSPlayer streamUrl={videoUrl} />
        )}
      </div>

      {/* STUDENT GUIDANCE COLLAPSIBLE V1 */}
      <aside className="student-exploration-card">
        <div className="student-exploration-eyebrow">
          STUDYAI LEARNING GUIDANCE
        </div>
        <h3>Have a Doubt? Explore, Experiment &amp; Learn!</h3>
        <p>
          Facing doubts is a natural part of becoming a skilled developer.
          The goal is not just to find answers, but to develop the ability
          to solve problems independently.
        </p>
        <details className="student-guidance-details">
          <summary>Read full guidance</summary>
          <div className="student-guidance-more">


        <p>
          AI and software development are fields of continuous exploration.
          Watching lectures is only the beginning. Whenever you face a doubt,
          revisit the concept, reproduce examples, experiment with code,
          investigate errors, consult documentation, search Google, and use
          tools like ChatGPT or Claude to understand different approaches.
        </p>

        <p>
          If you're still unable to resolve your doubt after genuinely
          exploring, email our academic team with your classroom ID, full
          name, lecture topic, exact doubt, and the approaches you've
          already attempted.
        </p>

        <p>
          Our team will review your question as soon as reasonably possible.
        </p>

        <p>
          <strong>Remember:</strong> The ability to explore, research,
          think from different perspectives, and solve problems
          independently is one of the most valuable skills of a
          successful developer.
        </p>

        <p>
          That's why we strongly encourage you to find answers to your
          doubts through your own exploration. This process helps you
          discover deeper explanations, understand problems from multiple
          angles, and develop your own problem-solving abilities.
        </p>

        <p>
          <strong>
            Learning technologies is only a small part of success.
            Real growth begins when your mind learns to explore,
            question, experiment, and create solutions independently.
          </strong>
          {" "}Our goal is to develop that ability in you. So whenever
          you face a doubt, challenge yourself to explore and resolve
          it on your own first.
        </p>
      
          </div>
        </details>
      </aside>
    </div>
  );
};

export default ViewVideo;
